/**
 * Impresa - SPECIFICHE 2.3
 *
 * Anagrafica imprese, una riga per impresa per cassa.
 * La stessa impresa può esistere in entrambe le casse con codici diversi.
 */
import { z } from 'zod';
import { CassaCodeSchema, str, dateStr } from './common.ts';

export const ImpresaSchema = z.object({
  id: z.number(),
  cassa: CassaCodeSchema,
  codImp: z.string(), // questo dato per nuove imprese ancora non lo so
  ragioneSociale: str, // required
  partitaIva: str, // required ma può essere anche un codice fiscale (va prima di codice fiscale)
  codiceFiscale: str, // required ma può essere anche una partita IVA 
  indirizzo: str,
  cap: str,
  citta: str,
  provincia: str,
  telefono: str,
  cellulare: str,
  fax: str,
  email: str,
  dataIscrizione: dateStr,
  dataCessazione: dateStr,
  ccnl: str,
  codiceConsorzio: str,
  codicePagamento: str,
  ac: str,
  albo: str,
  numOperai: str,
  dataSospensione: dateStr,
  tipoServizio: str,
  codce: str, // Codice impresa cassa
  createdAt: str,
  updatedAt: str,
});

export type Impresa = z.infer<typeof ImpresaSchema>;

// Per INSERT (senza id e timestamp)
export type ImpresaInsert = Omit<Impresa, 'id' | 'createdAt' | 'updatedAt'>;
